import * as React from 'react';

import {colors} from '../../colors/colors';
import {Divider} from '../../layout/divider';
import {SubSidebarHeader} from '../../sidebar/sub-sidebar-header/sub-sidebar-header';

import type {Session} from '../visitor-content/session-details/session-details';

import styles from './sessions-content.module.css';

type Props = {
    session: Session;
    sessionsTimeline: React.ReactNode;
    onClickBack: () => void;
};

export function SessionsContent(props: Props) {
    const headerRef = React.useRef(null);
    const timelineRef = React.useRef(null);

    React.useLayoutEffect(() => {
        if (headerRef && headerRef.current && timelineRef && timelineRef.current) {
            // Height needs to be calculated to account for header
            // @ts-expect-error
            timelineRef.current.style.height = `calc(100% - ${headerRef.current.clientHeight}px)`;
        }
    }, []);

    return (
        <div className={styles['sessions-content']}>
            <SubSidebarHeader
                title='Site visits'
                subtitle={
                    <>
                        {props.session.totalVisitDuration}
                        <Divider variant='dot' spacing={4} color={colors.greyLt} />
                        {props.session.numVisits} {props.session.numVisits === 1 ? 'page' : 'pages'}
                    </>
                }
                onClickBack={props.onClickBack}
                getRef={headerRef}
            />
            <div ref={timelineRef} className={styles['sessions-timeline-container']}>
                {props.sessionsTimeline}
            </div>
        </div>
    );
}
